'use client';

import { FOCUS_RING } from '@common/components/interaction';
import SvgChevronright from '@common/icon/SvgChevronright';
import { cn } from '@core/utils';
import Image from 'next/image';
import { useState } from 'react';

import { RegionFinderDialog } from './RegionFinderDialog';

interface RegionFinderEntryProps {
  className?: string;
}

export const RegionFinderEntry = ({ className }: RegionFinderEntryProps) => {
  const [isDialogOpened, setIsDialogOpened] = useState(false);

  return (
    <div
      className={cn(
        'w-full px-40 content-container',
        'mobile-tablet:px-20',
        className,
      )}
    >
      <button
        className={cn(
          'group flex h-56 w-full items-center justify-center gap-16 rounded-medium px-16',
          'border border-O-100 bg-O-25 hover:bg-O-50 active:bg-O-100',
          'transition-colors duration-150 motion-reduce:transition-none',
          FOCUS_RING,
        )}
        onClick={() => setIsDialogOpened(true)}
      >
        <span className="flex min-w-0 items-center gap-8">
          <Image
            src="/assets/pngs/region-finder-pin.png"
            alt=""
            width={20}
            height={20}
            className="shrink-0"
          />
          <span className="truncate font-600 text-Gray-800 typo-body4">
            지역별 답례품 찾기
          </span>
        </span>
        <SvgChevronright className="size-14 shrink-0 text-Gray-800 transition-transform duration-150 group-hover:translate-x-1 group-focus-visible:translate-x-1 motion-reduce:transition-none" />
      </button>

      <RegionFinderDialog
        opened={isDialogOpened}
        onClose={() => setIsDialogOpened(false)}
      />
    </div>
  );
};
